/* eslint-disable max-lines */
import { Modal, Form, Row, Col, Input, Space, Typography, Alert, Select } from "antd"
import {
  FieldLabel,
  SelectField,
  MultipleTextField,
  MultipleDateRangeField,
  UploadButtonForm
} from "../../../shared"
import { useContext, useEffect, useState } from "react"
import { getSelectValue, toFileList, Bugsnag } from "../../../../helpers"
import { verificationTypes } from "../../../../helpers/selectOptions/implementer/submission"
import PropTypes from "prop-types"
import { CommentsContext } from "../../../../contexts/admin/submissions/review/comments/context"
import moment from "moment"
import { v4 as uuid } from "uuid"
import { calculateMonthlyAverage } from "../../../../helpers/calculateMonthAverage"

ActivityModal.propTypes = {
  activityType: PropTypes.string,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  readOnly: PropTypes.bool,
  limitDates: PropTypes.array,
  edit: PropTypes.object,
  hiddenComments: PropTypes.object,
  review: PropTypes.bool
}

export function ActivityModal ({
  activityType,
  onSave,
  onCancel,
  readOnly,
  limitDates,
  edit,
  rol,
  hiddenComments,
  review,
  implementationPlace,
  ...props
}) {
  const [form] = Form.useForm()
  const { updateEntities } = useContext(CommentsContext)
  const [isBlocking, setIsBlocking] = useState(false)
  const [lugaresImplementacion, setLugaresImplementacion] = useState([])
  useEffect(() => {
    if (edit) {
      setIsBlocking(edit.isBlocking && rol);
      form.setFieldsValue(edit)
      edit?.id && updateEntities([{ entity: "activity", id: edit.id }])
    }
  }, [edit])

  useEffect(()=>{

    if(implementationPlace){
      setLugaresImplementacion(implementationPlace.filter((item)=> !item.isBlocking ).map(item => ({
            label: item.place, 
            value: item.id
      })))
    }
          
  },[implementationPlace])

  const onOk = async () => {
    try {
      await form.validateFields()
      let values = await form.getFieldsValue()

      if (typeof edit?.index !== "undefined") {
        edit.months = null
        edit.meansOfVerification = null
        delete edit.products
        delete edit.inputs
        values = {
          ...edit,
          ...values,
          place: values.place?.filter(Boolean)
        }
      }

      onSave({ ...values, tempId: uuid() })
      form.resetFields()
    }
    catch (e) {
      Bugsnag.notify(new Error(e))
      console.error(e)
    }
  }

  const onCancelModal = () => {
    form.resetFields()
    onCancel && onCancel()
  }

  const onDoneFile = async files => {
    const documents = files?.map(el => {
      return { name: el.name, url: el.url }
    })
    try {
      form.setFieldsValue({ metodologyDocuments: documents })
    }
    catch (e) {
      Bugsnag.notify(new Error(e))
      console.error(e)
    }
  }

  const onRemoveFile = async ({ url }) => {
    const oldDocuments = form.getFieldValue("metodologyDocuments")
    const documents = oldDocuments?.filter(document => document.url !== url)
    form.setFieldsValue({ metodologyDocuments: documents })
  }

  if (edit) {
    form.validateFields()
  }

  useEffect(() => {
    if (edit) {
      setIsBlocking(edit.isBlocking && rol)

      form.setFieldsValue({
        ... edit, 
        monthlyAverage: calculateMonthlyAverage (edit.goal, edit.months)
      })
  
      edit?.id && updateEntities([{ entity: "activity", id: edit.id }])
    }
  }, [edit])

  const handleValuesChange = (_, allValues) => {
    const { goal, months } = allValues
  
    const monthlyAverage = calculateMonthlyAverage(goal, months)
  
    form.setFieldsValue({ monthlyAverage })
  }

  return (
    <Modal
      title={`${edit ? "Editar" : "Agregar"} actividad`}
      onOk={onOk}
      onCancel={onCancelModal}
      okButtonProps={{ disabled: review ||  isBlocking }}
      width={800}
      okText={`${edit ? "Guardar" : "Agregar"}`}
      destroyOnClose={true}
      cancelText={(review ||  isBlocking) ? "Cerrar" : "Cancelar"}
      maskClosable={false}
      {...props}>
      <Form
        form={form}
        name="indicator-form"
        layout="vertical"
        onValuesChange={handleValuesChange}>
        <Row gutter={[10, 8]} justify="start">
          <Col span={24}>
            <Form.Item
              name="title"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "title",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Actividad
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="title"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="description"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "description",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Indicador
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="description"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="responsible"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "responsible",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Responsable
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="responsible"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="methodology"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "methodology",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Metodología
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="methodology"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={24} style={{ marginBottom: "10px" }}>
            <Form.Item
              name="metodologyDocuments"
              label={
                <Space direction="vertical">
                  <Typography.Text>
                    Documentos de metodología
                  </Typography.Text>
                  <Typography.Text style={{ color: "#949494" }}>
                    Adjunta la carta descriptiva de la actividad y/o cualquier{" "}
                    documento que sea necesario para entender la metodología.
                  </Typography.Text>
                </Space>
              }
              style={{ display: "inline" }}>
              <UploadButtonForm
                maxFile={5}
                disabled={ isBlocking}
                onRemoveFile={onRemoveFile}
                onChange={onDoneFile}
                fileList={toFileList(edit?.metodologyDocuments || [])}>
                Adjuntar Documentos
              </UploadButtonForm>
            </Form.Item>
            <br></br>
          </Col>
          <Col span={12}>
            <Form.Item
              name="formula"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "formula",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Fórmula
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="formula"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="meansOfVerification"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "meansOfVerification",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Medio de verificación
                </FieldLabel>
              }
              getValueFromEvent={getSelectValue}>
              <SelectField
                id="meansOfVerification"
                disabled={ isBlocking}
                filterOption={(value, option) => option.children.toLowerCase().includes(value.toLowerCase())}
                mode="multiple"
                showSearch
                options={verificationTypes} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="baseline"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "baseline",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Línea base
                </FieldLabel>
              }>
              <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="baseline"
                type="text" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="goal"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "goal",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Meta
                </FieldLabel>
              }>
              <Input
                autoSize
                disabled={ isBlocking}
                id="goal"
                type="number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="place"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "place",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Lugar de implementación
                </FieldLabel>
              }>
              {/* <Input.TextArea
                autoSize
                disabled={ isBlocking}
                id="place"
                type="text" /> */}
                <Select
                  id="place"
                  mode="multiple"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Seleccione los lugares de implementación"
                  options={lugaresImplementacion}
                />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="months"
              style={{ display: "inline" }}
              rules={[
                {
                  required: false,
                  message: "El campo es requerido"
                },
                () => ({
                  /**
                   * It validates that the dates selected by the user are within the range of the
                   * submission dates
                   * @param _ - The first parameter is the form instance.
                   * @param value - The value of the field.
                   * @returns A function that takes two parameters, the first one is the form and the
                   * second one is the value of the field.
                   */
                  validator (_, value) {
                    if (!value || !value.length) {
                      return Promise.reject("Meses de implementación es un campo obligatorio")
                    }

                    let isInRange = true
                    let valueExists = true

                    const submissionDates = {
                      submissionStarts: moment(moment(limitDates[0]).format("DD-MM-YYYY"), "DD-MM-YYYY"),
                      submissionEnds: moment(moment(limitDates[1]).format("DD-MM-YYYY"), "DD-MM-YYYY")
                    }

                    /* Checking if the activity dates are within the submission dates. */
                    value.forEach(month => {
                      if (!month || month.length <= 0) {
                        valueExists = false
                        return
                      }
                      const { submissionStarts, submissionEnds } = submissionDates
                      const activityStarts = moment(moment(month[0]).format("DD-MM-YYYY"), "DD-MM-YYYY")
                      const activityEnds = moment(moment(month[1]).format("DD-MM-YYYY"), "DD-MM-YYYY")

                      const compStarts =
                        (activityStarts.isBetween(submissionStarts, submissionEnds)
                          || activityStarts.isSame(submissionStarts))
                          ? true : false

                      const compEnds =
                        (activityEnds.isBetween(submissionStarts, submissionEnds)
                          || activityEnds.isSame(submissionEnds))
                          ? true : false

                      if (!compStarts || !compEnds) {
                        isInRange = false
                      }
                    })

                    if (!valueExists) {
                      return Promise.reject("Introduce una fecha valida")
                    }

                    if (!isInRange) {
                      return Promise.reject(
                        new Error(
                          `Alguno(s) de tus meses de implementación 
                          están fuera de la fecha de implementación de la solicitud 
                          (${submissionDates.submissionStarts.format("DD/MM/YYYY")} 
                          - 
                          ${submissionDates.submissionEnds.format("DD/MM/YYYY")})`
                        ))
                    }
                    return Promise.resolve()
                  }
                })
              ]}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "months",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                Meses de implementación *
                </FieldLabel>
              }>
              <MultipleDateRangeField
                dateRangesDisabled={review ||  isBlocking}
                isAddDisabled={review ||  isBlocking}
                limitDates={limitDates}
                review={review ||  isBlocking} />
            </Form.Item>
          <Col span={24}>
            <Form.Item colon={false} style={{ marginBottom: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <FieldLabel comentable={null}>
              Meta promedio mensual: 
               </FieldLabel>
              <Form.Item name="monthlyAverage" noStyle>
                <input type="hidden" />
              </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
              prevValues.monthlyAverage !== currentValues.monthlyAverage } >
              {({ getFieldValue }) => (
              <span style={{ fontWeight: 'bold' }}>{getFieldValue("monthlyAverage")?.toFixed(2)}</span> )}
            </Form.Item>
            { !hiddenComments && (
            <FieldLabel comentable={{
              hidden: hiddenComments,
              name: "monthlyAverage",
              section: activityType,
              entityId: edit?.id,
              entity: "activity"
            }}/>
          )}
          </div>
          </Form.Item>
          </Col>
          </Col>
          <Col span={24}>
            <Form.Item
              name="inputs"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "inputs",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Insumos
                </FieldLabel>
              }>
              <MultipleTextField
                isAddDisabled={review ||  isBlocking}
                isfileDisabled={review ||  isBlocking}
                addLabel="Agregar insumo"
                review={review ||  isBlocking} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="products"
              style={{ display: "inline" }}
              label={
                <FieldLabel comentable={{
                  hidden: hiddenComments,
                  name: "products",
                  section: activityType,
                  entityId: edit?.id,
                  entity: "activity"
                }}>
                  Productos
                </FieldLabel>
              }>
              <MultipleTextField
                isAddDisabled={review ||  isBlocking}
                addLabel="Agregar producto"
                review={review ||  isBlocking} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
